'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */

var checkType = require('zero-lang/type');

var doubleDigit = function doubleDigit(n) {
    return n < 10 ? '0' + n : n;
};
var lms = function lms(ms) {
    var str = ms + '';
    var len = str.length;
    return len === 3 ? str : len === 2 ? '0' + str : '00' + str;
};

module.exports = function (date, pattern) {
    /*
     * @reference   : https://github.com/dojo/dojo/blob/master/json.js#L105
     * @description : return stringified date according to given pattern.
     * @parameter*  : {date  } date, input Date object
     * @parameter   : {string} pattern, defines pattern for stringify.
     * @parameter   : {string} pattern, defines pattern for stringify.
     * @return      : {string} result string.
     * @syntax      : fmtDate(date, [pattern])
     * @example     :
     //    '{FullYear}-{Month}-{Date}T{Hours}:{Minutes}:{Seconds}.{Milliseconds}Z' => '2013-10-03T00:57::13.180Z'
     */
    if (checkType.isDate(date)) {
        pattern = pattern || '{FullYear}-{Month}-{Date}T{Hours}:{Minutes}:{Seconds}Z';

        return pattern.replace(/\{(\w+)\}/g, function (t, prop) {
            var fullProp = 'get' + (prop === 'Year' ? prop : 'UTC' + prop);
            var num = date[fullProp]() + (prop === 'Month' ? 1 : 0);
            return prop === 'Milliseconds' ? lms(num) : doubleDigit(num);
        });
    } else {
        throw 'not a Date instance';
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-fmt/date.js
 ** module id = 15
 ** module chunks = 0 1
 **/